import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    standalone: true, 
    name: 'lockTimer',
})
export class LockTimerPipe implements PipeTransform {
    transform(value: number) {
        const minutes: number = Math.floor(value / 60);
        return minutes + ':' + this.getSeconds(value - minutes * 60);
    }


    getSeconds(value: number): string {
        return value >= 10 ? value.toString() : `0${value}`;
    }
}